export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=3760d206&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/general.vue?vue&type=template&id=3760d206&scoped=true
// module id = gBwY
// module chunks = 0